import React, { PureComponent } from 'react'

import DiagnoseScreen from './component'
import Overlay from '../../Atoms/Overlay'
import API from '../../../services/api'
import AdminAPI from '../../../services/admin-api'

class DiagnoseContainer extends PureComponent {
  state = {
    gameApiChecking: false,
    gameApiCheckComplete: false,
    gameApiError: null,
    eventApiChecking: false,
    eventApiCheckComplete: false,
    eventApiError: null
  }

  handleGameApiStatusCheck = async () => {
    this.setState({ gameApiChecking: true, gameApiError: null })
    try {
      await API.getStatus()
      this.setState({ gameApiChecking: false, gameApiCheckComplete: true })
    } catch (e) {
      this.setState({ gameApiChecking: false, gameApiError: e })
    }
  }

  handleEventApiStatusCheck = async () => {
    this.setState({ eventApiChecking: true, eventApiError: null })
    try {
      await AdminAPI.getStatus()
      this.setState({ eventApiChecking: false, eventApiCheckComplete: true })
    } catch (e) {
      this.setState({ eventApiChecking: false, eventApiError: e })
    }
  }

  render () {
    return (
      <Overlay>
        <DiagnoseScreen
          gameApiChecking={this.state.gameApiChecking}
          gameApiCheckComplete={this.state.gameApiCheckComplete}
          gameApiError={this.state.gameApiError}
          onGameApiStatusCheck={this.handleGameApiStatusCheck}
          eventApiChecking={this.state.eventApiChecking}
          eventApiCheckComplete={this.state.eventApiCheckComplete}
          eventApiError={this.state.eventApiError}
          onEventApiStatusCheck={this.handleEventApiStatusCheck}
        />
      </Overlay>
    )
  }
}



export default DiagnoseContainer
